import { render, staticRenderFns } from "./AzconChipSwiper.vue?vue&type=template&id=0c326b58&scoped=true"
import script from "./AzconChipSwiper.vue?vue&type=script&lang=js"
export * from "./AzconChipSwiper.vue?vue&type=script&lang=js"
import style0 from "./AzconChipSwiper.vue?vue&type=style&index=0&id=0c326b58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c326b58",
  null
  
)

export default component.exports